import React from 'react';
import BaseIcon, { IconProps } from './Base.icon';

const ArchiveIcon = ({ width, height }: IconProps) => {
  return (
    <BaseIcon width={width} height={height} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3C14 2.45 13.55 2 13 2H3C2.45 2 2 2.45 2 3V4H14V3ZM12 0H4C3.45 0 3 0.45 3 1H13C13 0.45 12.55 0 12 0ZM15 5H1C0.45 5 0 5.45 0 6V15C0 15.55 0.45 16 1 16H15C15.55 16 16 15.55 16 15V6C16 5.45 15.55 5 15 5ZM12 11C12 11.55 11.55 12 11 12H5C4.45 12 4 11.55 4 11V9H5V11H11V9H12V11Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default ArchiveIcon;
